.page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.head {
  display: grid;
  gap: 4px;
}

.layout {
  display: grid;
  grid-template-columns: 360px minmax(0, 1fr);
  gap: 16px;
  align-items: stretch;
}

.listPane,
.chatPane {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.listPane {
  border: 1px solid var(--line);
  border-radius: 24px;
  background: color-mix(in srgb, var(--surface) 70%, transparent);
  overflow: hidden;
}

.listHead {
  display: grid;
  gap: 10px;
  padding: 12px 12px 0;
  border-bottom: 1px solid var(--line);
}

.search {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 6px 0 14px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: var(--surface);
}

.search input {
  flex: 1;
  min-width: 0;
  height: 38px;
  padding: 0;
  border: 0;
  background: transparent;
}

button.sortBtn {
  padding: 4px 10px;
  border: 0;
  border-radius: 999px;
  background: var(--pill-bg);
  color: var(--muted);
  font-size: 12px;
  white-space: nowrap;
}

.tabs {
  display: flex;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}

button.tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px 8px;
  border: 0;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  background: none;
  color: var(--muted);
  font-size: 13.5px;
  white-space: nowrap;
}

button.tab[aria-selected='true'] {
  border-bottom-color: var(--accent);
  color: var(--text);
}

.tabCount {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--pill-bg);
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
  display: grid;
  place-items: center;
}

.tabCount[data-hot='true'] {
  background: var(--accent);
  color: var(--on-fill);
  font-weight: 500;
}

.queue {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

button.row {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  padding: 11px 14px;
  border: 0;
  border-bottom: 1px solid var(--line);
  border-radius: 0;
  background: transparent;
  color: var(--text);
  font-weight: 400;
  text-align: left;
}

button.row:hover {
  background: var(--pill-bg);
}

button.row[aria-current='true'] {
  background: var(--pill-bg);
  box-shadow: inset 3px 0 0 var(--accent);
}

.avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  border: 1.5px solid var(--line);
  background: var(--surface);
  color: var(--accent);
  font-family: var(--font-display);
  font-size: 18px;
}

.avatar[data-tone='new'] {
  border-color: var(--accent);
}

.avatar[data-tone='ready'] {
  border-color: #4caf7a;
}

.avatar[data-tone='off'] {
  opacity: 0.7;
}

.rowMain {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.rowTop,
.queueTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.person {
  min-width: 0;
  overflow: hidden;
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row[data-unread='true'] .person {
  font-weight: 500;
}

.time {
  color: var(--muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.time[data-wait='true'] {
  color: var(--accent);
}

.preview {
  overflow: hidden;
  color: var(--muted);
  font-size: 13.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row[data-unread='true'] .preview {
  color: var(--text);
}

.rowSub {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: var(--muted);
  font-size: 12px;
}

.dot {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.dot::before {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--muted);
}

.dot[data-tone='new']::before,
.dot[data-tone='work']::before {
  background: var(--accent);
}

.dot[data-tone='ready']::before {
  background: #4caf7a;
}

.dot[data-tone='off']::before {
  background: #e5484d;
}

.topic {
  justify-self: start;
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--accent) 18%, transparent);
  color: var(--text);
  font-size: 12px;
  white-space: nowrap;
}

.empty {
  padding: 32px 20px;
  color: var(--muted);
  text-align: center;
}

.chatWrap {
  display: flex;
  gap: 16px;
  flex: 1;
  min-height: 0;
}

.chatMain {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.chatInfo {
  display: none;
  max-height: 40%;
}

.chatInfo[data-open='true'] {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.sideCol {
  display: none;
}

.chatBar {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.chatBar button {
  padding: 6px 14px;
  font-size: 13px;
}

button.backBtn {
  display: none;
  margin-right: auto;
}

.chatBox {
  container-type: size;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  border: 1px solid var(--line);
  border-radius: 24px;
  background: color-mix(in srgb, var(--surface) 70%, transparent);
}

.chatBox > * {
  flex: 1 0 auto;
}

.side {
  display: grid;
  gap: 12px;
  align-content: start;
  min-height: 0;
  overflow-y: auto;
}

.context {
  display: grid;
  gap: 8px;
  padding: 16px;
  border: 1px solid var(--line);
  border-radius: 20px;
  background: var(--bg-raised);
}

.contextRow {
  display: flex;
  gap: 12px;
  align-items: center;
}

.contextText {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.traits {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 2px;
  margin: 4px 0 0;
  font-size: 13px;
}

.traits dt {
  color: var(--muted);
  font-size: 12px;
}

.traits dd {
  margin: 0 0 6px;
}

.meta {
  color: var(--muted);
  font-size: 12px;
}

.history {
  display: grid;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.history li {
  display: grid;
  gap: 4px;
}

.historyText {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 13px;
}

.composer {
  position: sticky;
  bottom: 0;
  display: grid;
  gap: 10px;
  max-height: min(72cqh, calc(100cqh - 150px));
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 12px 16px 16px;
  border-top: 1px solid var(--line);
  background: color-mix(in srgb, var(--bg-raised) 94%, transparent);
  backdrop-filter: blur(12px);
}

.composer textarea,
.composer input {
  width: 100%;
}

.composer textarea {
  min-height: 96px;
  max-height: 36cqh;
  resize: vertical;
}

.composerHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.composerTitle {
  flex: 1;
  font-family: var(--font-display);
  font-size: 18px;
}

.composerHead button {
  padding: 6px 14px;
  font-size: 13px;
}

button.linkBtn {
  padding: 6px 4px;
  border: 0;
  background: none;
  color: var(--accent);
  font-size: 13px;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.recorder {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  min-height: 52px;
}

.recStart {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.recDot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e5484d;
  animation: rec-pulse 1.2s ease-in-out infinite;
}

.recDot[data-paused='true'] {
  animation: none;
  opacity: 0.4;
}

@keyframes rec-pulse {
  50% {
    opacity: 0.35;
  }
}

.recTime {
  font-variant-numeric: tabular-nums;
  min-width: 44px;
}

.recWave {
  flex: 1;
  min-width: 120px;
  height: 32px;
}

.recPreview {
  flex: 1;
  min-width: 220px;
}

.picker {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.pickerHead {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
}

.pickerHead span {
  flex: 1;
  text-align: right;
  color: var(--muted);
  font-size: 12.5px;
}

.strip {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 60px;
  gap: 8px;
  padding: 6px 6px 8px 2px;
  min-width: 0;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scroll-snap-type: x proximity;
}

.strip button {
  position: relative;
  min-width: 0;
  padding: 0;
  border: 0;
  background: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: var(--muted);
  font-size: 10.5px;
  line-height: 1.2;
  text-align: center;
  scroll-snap-align: start;
}

.strip img {
  width: 100%;
  max-width: 72px;
  aspect-ratio: 180 / 314;
  object-fit: contain;
  opacity: 0.78;
}

.strip button[aria-pressed='true'] {
  color: var(--text);
}

.strip button[aria-pressed='true'] img {
  filter: drop-shadow(0 0 4px var(--accent));
  opacity: 1;
  box-shadow: 0 6px 16px color-mix(in srgb, var(--accent) 35%, transparent);
}

.strip button[aria-pressed='true']::after {
  content: '✓';
  position: absolute;
  top: -4px;
  right: -4px;
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--accent);
  color: var(--bg);
  font-size: 12px;
}

.sendRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.closedNote {
  position: sticky;
  bottom: 0;
  padding: 14px 16px;
  border-top: 1px solid var(--line);
  background: color-mix(in srgb, var(--bg-raised) 94%, transparent);
  color: var(--muted);
  font-size: 14px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.offerRow {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.offerRow:empty {
  display: none;
}

.offerFlag {
  font-size: 12.5px;
  color: var(--accent);
  padding: 3px 12px;
  border-radius: 99px;
  border: 1px dashed var(--pill-line, var(--line));
  white-space: nowrap;
}

@media (min-width: 1081px) {
  .page {
    height: calc(100dvh - 56px);
    margin-bottom: -40px;
  }

  .layout {
    flex: 1;
    min-height: 0;
  }

  .chatBox {
    flex: 1;
  }
}

@media (min-width: 1200px) {
  .chatInfo[data-open],
  .chatInfo {
    display: none;
  }

  .infoBtn {
    display: none;
  }

  .sideCol {
    display: flex;
    flex-direction: column;
    flex: 0 0 320px;
    min-height: 0;
  }
}

@media (max-width: 1080px) {
  .layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .layout[data-opened='true'] .listPane,
  .layout:not([data-opened='true']) .chatPane {
    display: none;
  }

  .listPane {
    max-height: calc(100dvh - 180px);
  }

  button.backBtn {
    display: inline-flex;
  }

  .chatBox {
    height: 80vh;
  }
}

.formatTag {
  margin-right: 6px;
  padding: 1px 7px;
  border-radius: 99px;
  font-weight: 500;
  color: var(--accent);
  background: color-mix(in srgb, var(--accent) 12%, transparent);
}
